export default "__VITE_ASSET__BeSI_t8d__"